// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cd9ef4b7","488":"a037a353","553":"a4a433d5","977":"de1f34d8"}[chunkId] + ".chunk.js";
};